import React, {Suspense, lazy, useEffect} from "react";
import ScrollToTop from "./helpers/scroll-top";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import DemoShopModal from "./components/DemoShopModal";
import Confirmation from "./pages/other/Confirmation";
import {ProductFruits} from "react-product-fruits";
import {useDispatch, useSelector} from "react-redux";
import {v4 as uuidv4} from 'uuid';
import {setUserName} from "./store/slices/user-data-slice";

// home pages
const HomeFashionFour = lazy(() => import("./pages/home/HomeFashionFour"));
// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));
const ProductTabLeft = lazy(() =>
    import("./pages/shop-product/ProductTabLeft")
);
const ProductTabRight = lazy(() =>
    import("./pages/shop-product/ProductTabRight")
);
const ProductSticky = lazy(() => import("./pages/shop-product/ProductSticky"));
const ProductSlider = lazy(() => import("./pages/shop-product/ProductSlider"));
const ProductFixedImage = lazy(() =>
    import("./pages/shop-product/ProductFixedImage")
);

// other pages
const Contact = lazy(() => import("./pages/other/Contact"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));
const ControlTower = lazy(() => import("./pages/other/ControlTower"));

const Demo = lazy(() => import("./pages/track-embed-demo/Demo"));

const App = () => {
    const dispatch = useDispatch();
    const userInfoObject = useSelector(state => state.user.userData);
    useEffect(() => {
        if (!userInfoObject.username) {
            const uuidString = uuidv4();
            dispatch(setUserName(uuidString));
        }
    }, [userInfoObject])

    if (!userInfoObject.username) {
        return 'Loading...'
    }


    return (
        <>
            <ProductFruits workspaceCode="QtpAGYIzHNxrY3qE" language={localStorage.getItem('i18nextLng')} user={userInfoObject}/>
            <Router>
                <ScrollToTop>
                    <Suspense
                        fallback={
                            <div className="flone-preloader-wrapper">
                                <div className="flone-preloader">
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        }
                    >
                        <Routes>
                            <Route
                                path={process.env.PUBLIC_URL + "/"}
                                element={<HomeFashionFour/>}
                            />


                            {/* Shop pages */}
                            <Route
                                path={process.env.PUBLIC_URL + "/shop-grid-standard"}
                                element={<ShopGridStandard/>}
                            />


                            {/* Shop product pages */}
                            <Route
                                path={process.env.PUBLIC_URL + "/product/:id"}
                                element={<Product/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL + "/product-tab-left/:id"}
                                element={<ProductTabLeft/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL + "/product-tab-right/:id"}
                                element={<ProductTabRight/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL + "/product-sticky/:id"}
                                element={<ProductSticky/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL + "/product-slider/:id"}
                                element={<ProductSlider/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL + "/product-fixed-image/:id"}
                                element={<ProductFixedImage/>}
                            />

                            {/* Other pages */}
                            <Route
                                path={process.env.PUBLIC_URL + "/contact"}
                                element={<Contact/>}
                            />

                            <Route
                                path={process.env.PUBLIC_URL + "/cart"}
                                element={<Cart/>}
                            />

                            <Route
                                path={process.env.PUBLIC_URL + "/control-tower"}
                                element={<ControlTower/>}
                            />

                            <Route
                                path={process.env.PUBLIC_URL + "/confirmation"}
                                element={<Confirmation/>}
                            />

                            <Route
                                path={process.env.PUBLIC_URL + "/wishlist"}
                                element={<Wishlist/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL + "/compare"}
                                element={<Compare/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL + "/checkout"}
                                element={<Checkout/>}
                            />
                            <Route
                                path={process.env.PUBLIC_URL+ "/demo"}
                                element={<Demo/>}
                            />

                            <Route path="*" element={<NotFound/>}/>
                        </Routes>
                    </Suspense>
                </ScrollToTop>
            </Router>
        </>
    );
};

export default App;
